export class Language {
    languageId: number;
    name?: string;
    createdBy: number;
    createdDate: Date;
    modifiedBy?: number;
    modifiedDate?: Date;
    totalItems?: number;
}